'use client';

import { Provider } from 'react-redux';
import { ChakraProvider } from '@chakra-ui/react';
import store from '@/redux/store';
import { theme } from '@/components/Theme';
import { ColorModeProvider } from '@/ColorModeContext';
import { AuthProvider } from '@/contexts/AuthContext';

export function Providers({ children }: { children: React.ReactNode }) {
    return (
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <ColorModeProvider>
                    <AuthProvider>
                        {children}
                    </AuthProvider>
                </ColorModeProvider>
            </ChakraProvider>
        </Provider>
    );
} 